import * as R from "ramda";

import { FETCH_COMPANIES } from "../actions/companies";
import { ADD_COMPANY } from "../actions/company";

export const initialState = null;

const companies = (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_COMPANIES.RESOLVED:
      return payload;

    case ADD_COMPANY.RESOLVED: {
      return R.pipe(
        R.defaultTo([]),
        R.append(payload)
      )(state);
    }
    default:
      return state;
  }
};

export default companies;
